import { render } from "./ButtonIconOnly.vue?vue&type=template&id=02fedb90"
import script from "./ButtonIconOnly.vue?vue&type=script&lang=js"
export * from "./ButtonIconOnly.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__